import React, { useEffect, useState } from "react";
import { connectDefaultPage } from "./defaultpage.connect";
import Promotion from "../../components/Promotion/promotion";
import InPlayPopular from "../../components/InPlay/inPlayPopular";
import { headerType } from "../../helpers/InPlayPopular.helper";
import { useSelector } from "react-redux";
import moment from "moment";
import leftSideMenuMapper from "../../helpers/getLeftSideMenuMapper.helper";
import {
  VirtualData,
  BallByBallData,
} from "../../constants/InplayVirtualObjects";
import HomeCasinoGrid from "../../components/HomeCasinoGridList/HomeCasinoGrid";
import { HomeGuideData } from "../../constants/GuideData";
import Accordion from "../../components/Accordion/Accordion";
import { GET_INPLAY_POPULAR_INTERVAL } from "../../config/app.config";
import { useLocation } from "react-router-dom";
import {
  clearIntervalAsync,
  setIntervalAsync,
} from "set-interval-async/dynamic";
import Marquee from "react-fast-marquee";

const DefaultPage = ({
  auth,
  user,
  news,
  lastActivityDate,
  inplayPopular,
  promotions,
  balanceSettings,
  legalAgePopoverShow,
  kycPopoverShow,
  moreRulesPopoverShow,
  timeSettings,
  betPlacing,
  orderCount,
  actions,
  elementsParams,
  fortuneWheel,
  menu,
  homeMarketEvents,
  openBets,

  ...props
}) => {
  const location = useLocation();
  const [displayedBack, setDisplayedBack] = useState(false);
  const navigationID = useSelector(
    (state) => state.navigationHeaderMenu.navigationID
  );
  const [inplayData, setInplayData] = useState([]);
  const [upcomingData, setUpcomingData] = useState([]);

  useEffect(() => {
    if (!menu || menu?.length <= 0) {
      actions.requestMenu();
    }
  }, [menu]);

  const getInplayPopular = async () => {
    actions
      .requestInplayPopular()
      .catch((e) => console.log("requestInplayPopular error = ", e));
  };

  useEffect(() => {
    !location.pathname.includes("event-page") &&
      auth &&
      actions.requestOpenBets();

    const interval = setInterval(() => {
      if (!location.pathname.includes("event-page") && auth) {
        actions.requestOpenBets();
      }
    }, 30000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [location, auth]);

  useEffect(() => {
    if (
      !inplayPopular &&
      (location.pathname === "/default-page" || location.pathname === "/")
    )
      getInplayPopular();
    else {
      let timer;
      if (auth) {
        timer = setIntervalAsync(async () => {
          if (
            location.pathname === "/default-page" ||
            location.pathname === "/"
          )
            await getInplayPopular();
        }, GET_INPLAY_POPULAR_INTERVAL);
      } else {
        timer = setIntervalAsync(async () => {
          if (
            location.pathname === "/default-page" ||
            location.pathname === "/"
          )
            await getInplayPopular();
        }, 60000);
      }
      return () => clearIntervalAsync(timer);
    }
  }, [inplayPopular, location.pathname]);

  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth;

  const isSportAvailable = (id) => {
    return menu.some((sport) => sport.sport_id === id);
  };

  return (
    <>
      <div
        className="w-full md:mt-[0px]   lg:overflow-auto lg:w-[54%]"
        style={{ minHeight: "calc(-54px + 100dvh)" }}
      >
        <div
          id="home"
          className=" py-1 flex  flex-col items-start justify-start"
        >
          <Marquee
            style={{
              background: "#1f2c3d",
              color: "#fff",
              borderRadius: "2px",
              margin: "6px 2px",
              padding: "0px 10px",
            }}
          >
            {news?.data?.map((item, key) => {
              return (
                <p
                  key={key}
                  style={{
                    fontSize: "14px",
                    padding: "5px 20px 5px 0px",
                    margin: "0px 10px",
                  }}
                >
                  {item.heading}
                </p>
              );
            })}
          </Marquee>
          <Promotion />

          {inplayPopular &&
            inplayPopular.filter(
              (item) =>
                item.inplay &&
                item?.sport_id !== "7" &&
                item?.sport_id !== "4339"
            ).length > 0 && (
              <InPlayPopular
                displayedBack={displayedBack}
                betPlacing={betPlacing}
                timeSettings={timeSettings}
                setDisplayedBack={setDisplayedBack}
                balanceSettings={balanceSettings && balanceSettings.settings}
                // inPlayEvents={inplayData}
                inPlayEvents={
                  inplayPopular &&
                  inplayPopular.filter(
                    (item) =>
                      item.inplay &&
                      item?.sport_id !== "7" &&
                      item?.sport_id !== "4339"
                  )
                }
                type={headerType["INPLAY"]}
                orderCount={
                  (openBets?.openBets && openBets?.openBets?.length) || 0
                }
                promotions={promotions}
                navigationID={navigationID}
              />
            )}

          {isSportAvailable("QT") ? (
            <HomeCasinoGrid
              itemHeaderData={leftSideMenuMapper["casino Providers"]}
            />
          ) : null}
          {isSportAvailable("QT") ? (
            <HomeCasinoGrid
              itemHeaderData={leftSideMenuMapper["Indian Card Games"]}
            />
          ) : null}
          {isSportAvailable("QT") ? (
            <HomeCasinoGrid
              itemHeaderData={leftSideMenuMapper["Popular Games"]}
            />
          ) : null}

          {inplayPopular &&
            inplayPopular.filter(
              (item) =>
                !item.inplay &&
                item?.sport_id !== "7" &&
                item?.sport_id !== "4339"
            )?.length > 0 && (
              <InPlayPopular
                displayedBack={displayedBack}
                betPlacing={betPlacing}
                timeSettings={timeSettings}
                setDisplayedBack={setDisplayedBack}
                balanceSettings={balanceSettings && balanceSettings.settings}
                // inPlayEvents={upcomingData}
                inPlayEvents={
                  inplayPopular &&
                  inplayPopular.filter(
                    (item) =>
                      !item.inplay &&
                      item?.sport_id !== "7" &&
                      item?.sport_id !== "4339"
                  )
                }
                type={headerType["POPULAR"]}
                orderCount={(orderCount && orderCount) || 0}
                promotions={promotions}
                navigationID={navigationID}
              />
            )}
        </div>

        {HomeGuideData.map((item, index) => {
          return (
            <article key={item?.id}>
              <div className={`${index == 0 ? "" : "py-1"} px-[6px]`}>
                <Accordion item={item} />
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
};

export default connectDefaultPage()(DefaultPage);
